import { paths } from '../../config/paths';

/** 로그인 후 복귀 경로 — 외부 URL·로그인 페이지 자기참조 차단 */
export function resolveLoginReturnPath(from, fallback = paths.home) {
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//')) {
    return fallback;
  }
  const pathOnly = from.split(/[?#]/)[0];
  if (pathOnly === paths.auth.login) {
    return fallback;
  }
  return from;
}
